import React, { memo, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
    applyFilters, getCrewList, getEgListWithCrew,
    clearCrewKanban, getGeoRegionList, setAssignedEg
} from "../../../actions/crew-kanban";
import { getEGReportIssue } from "../../../actions/equipment-group";
import SavingOverlay from "./SavingOverlay";
import BoardHeader from "./BoardHeader";
import BoardBody from "./BoardBody";

const Board = (props) => {
    const dispatch = useDispatch();
    const { farmId } = props;
    const refresh = useSelector(state => state.crewKanban.refresh);
    const filters = useSelector(state => state.crewKanban.filters);
    const columns = useSelector(state => state.crewKanban.columns);
    const selectedPlanTypeId = useSelector(state => state.plan.selectedPlanType);

    const { planTypeId, isSelectedPlanUpdated } = filters;
    const { range, customRange, custom: { from, to } } = useSelector(state => state.analyze.searchParams);
    useEffect(() => {
        if (selectedPlanTypeId !== 10) {
            dispatch(applyFilters({ farmId, planTypeId: selectedPlanTypeId, isSelectedPlanUpdated: true }));
            return () => dispatch(clearCrewKanban());
        }
    }, [selectedPlanTypeId, farmId]);

    useEffect(() => {
        if (farmId && planTypeId !== 10 /* && isSelectedPlanUpdated */) {
            dispatch(getEgListWithCrew({ farmId, planTypeId }));
            dispatch(getEGReportIssue(farmId));
        }
    }, [refresh, farmId, planTypeId, range, customRange, from, to, isSelectedPlanUpdated]);

    useEffect(() => {
        if (farmId && planTypeId !== 10 && isSelectedPlanUpdated) {
            dispatch(getCrewList({ farmId, planTypeId }));
        }
    }, [refresh, farmId, range, customRange, from, to, planTypeId, isSelectedPlanUpdated]);

    useEffect(() => {
        const rangeCustom = range.custom;
        if (farmId) {
            dispatch(getGeoRegionList(farmId, true, rangeCustom));
        }
    }, [farmId]);

    useEffect(() => {
        dispatch(setAssignedEg());
    }, [columns]);

    return (
        <>
            <SavingOverlay />
            <div className="crew-kanban-container">
                <BoardHeader />
                <BoardBody />
            </div>
        </>
    );
};

export default memo(Board);
